export const openDatabase = async () => {
  return new Promise((resolve, reject) => {
    window?.sqlitePlugin.openDatabase(
      {
        name: 'mc.db',
        location: 'default',
      },
      (result) => {
        console.log('Connection to DB opened')
        resolve(result)
      },
      (error) => {
        console.log('Error connecting to DB' + error.message)
        reject(error)
      }
    )
  })
}

export const initDatabase = async (db, table) => {
  return new Promise((resolve, reject) => {
    db.transaction(
      (tx) => {
        tx.executeSql(
          `CREATE TABLE IF NOT EXISTS ${table} (
            id INTEGER PRIMARY KEY AUTOINCREMENT, 
            songId TEXT, 
            indication TEXT,
            playMode TEXT, 
            sessionStart TEXT, 
            selectedDuration INTEGER, 
            painBefore INTEGER, 
            painAfter INTEGER, 
            playTime INTEGER, 
            endEvent TEXT, 
            sessionEnd TEXT,
            idempotencyKey TEXT
          )`,
          []
        )
      },
      (error) => {
        console.log('Transaction init ERROR: ' + error.message)
        reject(error)
      },
      () => {
        console.log('Populated database OK')
        resolve()
      }
    )
  })
}

export const insertSession = async (db, table, data) => {
  return new Promise((resolve, reject) => {
    db.transaction(
      (tx) => {
        tx.executeSql(
          `INSERT INTO ${table} (songId, indication, playMode, sessionStart, selectedDuration, painBefore, idempotencyKey) VALUES (?,?,?,?,?,?,?)`,
          [
            data.songId,
            data.indication,
            data.playMode,
            data.sessionStart,
            data.selectedDuration,
            data.painBefore,
            data.idempotencyKey,
          ]
        )
      },
      (error) => {
        console.log('Transaction insert ERROR: ' + error.message)
        reject(error)
      },
      () => {
        console.log('Session inserted')
        resolve()
      }
    )
  })
}

export const updateSession = async (db, table, data) => {
  return new Promise((resolve, reject) => {
    db.transaction(
      (tx) => {
        tx.executeSql(
          `UPDATE ${table} SET endEvent = ?, playTime = ?, painAfter = ?, sessionEnd = ? WHERE id = ?`,
          [data.endEvent, data.playTime, data.painAfter, data.sessionEnd, data.id]
        )
      },
      (error) => {
        console.log('Transaction update ERROR: ' + error.message)
        reject(error)
      },
      () => {
        console.log('Session updated')
        resolve()
      }
    )
  })
}

export const getLastId = async (db) => {
  return new Promise((resolve, reject) => {
    db.transaction((tx) => {
      tx.executeSql(
        `SELECT last_insert_rowid()`,
        [],
        (tx, rs) => {
          resolve(rs.rows.item(0)['last_insert_rowid()'])
        },
        (tx, error) => {
          console.log('SELECT error: ' + error.message)
          reject(error)
        }
      )
    })
  })
}

export const getSessions = async (db, table) => {
  return new Promise((resolve, reject) => {
    db.transaction((tx) => {
      tx.executeSql(
        `SELECT * FROM ${table} LIMIT 100`,
        [],
        (tx, rs) => {
          const result = []
          for (let row = 0; row < rs.rows.length; row++) {
            result.push(rs.rows.item(row))
          }
          resolve(result)
        },
        (tx, error) => {
          console.log('SELECT error: ' + error.message)
          reject(error)
        }
      )
    })
  })
}

export const deleteSessions = async (db, table, ids) => {
  return new Promise((resolve, reject) => {
    db.transaction(
      (tx) => {
        tx.executeSql(`DELETE FROM ${table} WHERE id IN (${ids})`, [])
      },
      (error) => {
        console.log('Transaction delete ERROR: ' + error.message)
        reject(error)
      },
      () => {
        console.log('Sessions deleted')
        resolve()
      }
    )
  })
}
